<template>
  <div>
    <div class="mb-3">
      <label for="">{{ 'Header' | translate }}</label>
      <input class="form-control" type="text" v-model="block.header" :placeholder="$t('Header')" maxlength="200" />
    </div>
    <div class="row">
      <div class="col-12">
        <ImageUpload
          :file-path="block.file"
          @uploadCompleted="storeFile"
          @fileDeleted="deleteFile"
          context="block.image"
        ></ImageUpload>
      </div>
      <div class="col-12">
        <div class="mt-3">
          <label>{{ 'Url' | translate }}</label>
          <input class="form-control" type="text" v-model="url" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import route from './../../routes.js'
import ImageUpload from './../ImageUpload'

export default {
  components: {
    ImageUpload,
  },
  props: ['block'],
  methods: {
    deleteFile() {
      this.block.file = null
      this.$emit('fileDeleted')
    },
    storeFile(filePath) {
      this.block.file = filePath
      this.$emit('fileUploaded')
    },
    img(url) {
      if (!url) {
        return false
      }
      return route.image(url)
    },
  },
  computed: {
    url: {
      get() {
        return _.get(this.block, 'settings.url', null)
      },
      set(url) {
        this.$set(this.block, 'settings', { ...this.block.settings, url })
      },
    },
    displayAsCard() {
      let display_as_card = _.get(this.block, 'settings.display_as_card')
      if (display_as_card) {
        return 'bg-white p-5'
      }
      return ''
    },
  },
}
</script>
